import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// const baseUrl = process.env.REACT_EASE_BUZZ_BACKEND_ENDPOINT;
const baseUrl = "https://backend.vaamozdevelop.xyz/VampayLiveApi";

export const easebuzzApi = createApi({
  reducerPath: "easebuzzApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Origin", "https://vaamoz.com");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    easebuzzDebitPayment: builder.mutation({
      query: ({
        txn_mode,
        card_number,
        card_holder_name,
        card_cvv,
        card_expiry_date,
        amount,
      }: {
        txn_mode: "DC" | "CC";
        card_number: string;
        card_holder_name: string;
        card_cvv: string;
        card_expiry_date: string;
        amount: string;
      }) => ({
        url: "/EasebuzzDebitPayment",
        method: "POST",
        body: {
          txn_mode,
          card_number,
          card_holder_name,
          card_cvv,
          card_expiry_date,
          amount,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
    easebuzzNetBanking: builder.mutation({
      query: ({ amount, bank }: { amount: string; bank: string }) => ({
        url: "/EasebuzzNetBanking",
        method: "POST",
        body: {
          amount,
          bank,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useEasebuzzDebitPaymentMutation,
  useEasebuzzNetBankingMutation,
} = easebuzzApi;
